/* 3.10.2026 (Pat): every product in the slide-in cart shows its earliest day ("najwcześniej sob. 3.10"); when the products
   differ, the one that takes longest is marked calmly (darker text, the day in bold: "… · najdłużej się przygotowuje"; Pat: no alarm look), so it is clear which product
   decides the date of the whole order. The cart page does the same in assets/batida-cart-v2.js (loadEarliest).

   Earliest day = Batida Connect's availability for that one product, pickup at the first boutique (as the cart page).
   Connect needs the product's tags (24h/48h/72h …), read from /products/<handle>.js. Answers are kept in sessionStorage
   for 15 minutes, so reopening the drawer costs nothing. New look (html.v7) only; texts: batida.cart_drawer.earliest /
   earliest_max (locales). Revert: remove the <script> in snippets/zip-cookies.liquid and this file. */
(function () {
  if (window.batidaEarliest || !document.documentElement.classList.contains('v7')) return;
  var API = (window.BatidaConnect && window.BatidaConnect.api) || 'https://batida-rates.azurewebsites.net/api/connect/';
  var ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
  var LANG = (document.documentElement.lang || 'pl').toLowerCase().split('-')[0];
  var TTL = 15 * 60 * 1000, SKIP = ['napis-na-torcie', 'wysylka-koszulki-inpost'];
  function t(k, fb) { return typeof window.batidaT === 'function' ? window.batidaT('cart_drawer.' + k, fb) : fb; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function cget(k) { try { var v = JSON.parse(sessionStorage.getItem('bE:' + k)); if (v && Date.now() - v.t < TTL) return v; } catch (e) {} return null; }
  function cset(k, v) { try { sessionStorage.setItem('bE:' + k, JSON.stringify({ t: Date.now(), v: v })); } catch (e) {} }
  function api(path, body) {
    return fetch(API + path, { method: body ? 'POST' : 'GET', headers: body ? { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' } : { Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined })
      .then(function (r) { if (!r.ok) throw new Error('api ' + r.status); return r.json(); });
  }
  function day(isoDate) {
    var d = new Date(isoDate + 'T12:00:00Z'), wd = '';
    try { wd = d.toLocaleDateString(LANG === 'uk' ? 'uk-UA' : LANG === 'en' ? 'en-GB' : LANG, { weekday: 'short', timeZone: 'UTC' }); } catch (e) {}
    return (wd ? wd + ' ' : '') + d.getUTCDate() + '.' + ('0' + (d.getUTCMonth() + 1)).slice(-2);
  }
  var locP = null;
  function firstLoc() {
    if (locP) return locP;
    var c = cget('loc');
    locP = c ? Promise.resolve(c.v) : api('config?locale=' + LANG).then(function (cfg) { var id = (cfg && cfg.pickup && cfg.pickup[0] && cfg.pickup[0].id) || null; if (id) cset('loc', id); if (cfg && cfg.pickup) cset('locs', cfg.pickup.map(function (l) { return l.id; })); return id; });
    locP.catch(function () { locP = null; });
    return locP;
  }
  /* 8.10 (Pat): a product with NO day at all (sales window over, e.g. the last day 9.10, or not bookable anywhere). Only
     marked after a 120-day check over every boutique + Warsaw delivery (02-512); any failed call = not marked. */
  var GONE = { pl: 'Nie można już zamówić - usuń z koszyka', en: 'No longer available to order - remove it', de: 'Nicht mehr bestellbar - bitte entfernen', fr: 'Plus disponible à la commande - à retirer', uk: 'Більше не можна замовити - видали' };
  function goneOf(item, loc) {
    var key = 'g:' + item.variant_id, c = cget(key);
    if (c) return Promise.resolve(!!c.v);
    var lc = cget('locs'), locs = lc && lc.v && lc.v.length ? lc.v : [loc];
    return tagsOf(item).then(function (tags) {
      var it = [{ productId: item.product_id, variantId: item.variant_id, quantity: 1, tags: tags, collections: [] }];
      var reqs = locs.map(function (l) { return { method: 'pickup', locationId: l, items: it, days: 120 }; });
      reqs.push({ method: 'delivery', postcode: '02-512', items: it, days: 120 });
      return Promise.all(reqs.map(function (q) { return api('availability', q); }));
    }).then(function (rs) {
      var none = rs.every(function (r) { return r && !r.error && (r.eligible === false || !(r.days || []).length); });
      cset(key, none); return none;
    });
  }
  function tagsOf(item) {
    var c = cget('tags:' + item.product_id);
    if (c) return Promise.resolve(c.v);
    return fetch('/products/' + encodeURIComponent(item.handle) + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : { tags: [] }; })
      .then(function (p) { var tg = p.tags || []; cset('tags:' + item.product_id, tg); return tg; });
  }
  function earliestOf(item, loc) {
    var key = 'v:' + item.variant_id + ':' + loc, c = cget(key);
    if (c) return Promise.resolve(c.v);
    return tagsOf(item).then(function (tags) {
      return api('availability', { method: 'pickup', locationId: loc, items: [{ productId: item.product_id, variantId: item.variant_id, quantity: 1, tags: tags, collections: [] }], days: 60 });
    }).then(function (r) { var d = (r && r.earliest && r.earliest.date) || null; cset(key, d); return d; });
  }
  /* {lineKey: 'YYYY-MM-DD'} for the cart's products (not the inscription add-on, the T-shirt fee or lines without shipping) */
  function forCart(cart) {
    var items = (cart && cart.items || []).filter(function (i) { return i.requires_shipping !== false && SKIP.indexOf(i.handle) < 0; });
    if (!items.length) return Promise.resolve({});
    return firstLoc().then(function (loc) {
      if (!loc) return {};
      return Promise.all(items.map(function (i) { return earliestOf(i, loc).catch(function () { return undefined; }); })).then(function (ds) {
        var out = {}, gone = {}; items.forEach(function (i, n) { if (ds[n]) out[i.key] = ds[n]; });
        // an empty (not failed) answer = candidate; confirmed by goneOf, a failure marks nothing
        return Promise.all(items.map(function (i, n) { return ds[n] === null ? goneOf(i, loc).then(function (g) { if (g) gone[i.key] = 1; }, function () {}) : null; })).then(function () {
          Object.defineProperty(out, 'gone', { value: gone, enumerable: false }); return out;
        });
      });
    });
  }
  /* the longest-taking day, or '' when every product can be ready on the same day (then nothing is highlighted) */
  function maxOf(map) {
    var ds = Object.keys(map).map(function (k) { return map[k]; });
    var mx = ds.reduce(function (m, d) { return d > m ? d : m; }, '');
    return ds.some(function (d) { return d !== mx; }) ? mx : '';
  }
  window.batidaEarliest = { forCart: forCart, maxOf: maxOf, day: day };

  // ---------- the slide-in cart (assets/batida-drawer.js renders the lines; this adds one row under each price) ----------
  var busy = false, timer = 0, seq = 0;
  function decorate() {
    var box = document.querySelector('[data-batida-cart-items]');
    if (!box || busy) return;
    var lines = box.querySelectorAll('.batida-cart-drawer__line[data-line-key]');
    if (!lines.length) return;
    var my = ++seq;
    fetch(ROOT + '/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(forCart).then(function (map) {
      if (my !== seq) return;
      var mx = maxOf(map);
      busy = true;
      box.querySelectorAll('.batida-cart-drawer__line[data-line-key]').forEach(function (el) {
        var d = map[el.getAttribute('data-line-key')], old = el.querySelector('.bce'), html = '';
        if (!d && map.gone && map.gone[el.getAttribute('data-line-key')]) html = '<p class="bce bce--gone">' + esc(t('unavailable', GONE[LANG] || GONE.en)) + '</p>';
        else if (d) {
          var isMax = d === mx;
          html = '<p class="bce' + (isMax ? ' bce--max' : '') + '">' + esc(isMax ? t('earliest_max', 'najwcześniej [day] · najdłużej się przygotowuje') : t('earliest', 'najwcześniej [day]')).replace('[day]', isMax ? '<b>' + esc(day(d)) + '</b>' : esc(day(d))) + '</p>';
        }
        if (old) { if (old.outerHTML === html) return; old.remove(); }
        if (!html) return;
        var price = el.querySelector('.batida-cart-drawer__line__price'), body = el.querySelector('.batida-cart-drawer__line__body');
        if (price) price.insertAdjacentHTML('afterend', html); else if (body) body.insertAdjacentHTML('beforeend', html);
      });
      busy = false;
    }).catch(function () { busy = false; });
  }
  function watch() {
    var box = document.querySelector('[data-batida-cart-items]');
    if (!box) return false;
    new MutationObserver(function () { if (busy) return; clearTimeout(timer); timer = setTimeout(decorate, 120); }).observe(box, { childList: true });
    decorate();
    return true;
  }
  var css = '.bce{margin:0 0 6px;font-size:12px;line-height:1.35;color:#6B625C}' +
    '.bce--max{color:#1A1512}.bce b{font-weight:700}.bce--gone{color:#8A3A41;font-weight:600}';
  var st = document.createElement('style'); st.textContent = css; (document.head || document.documentElement).appendChild(st);
  function start() { if (watch()) return; var n = 0, iv = setInterval(function () { if (watch() || ++n > 40) clearInterval(iv); }, 250); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
